import React, { useState, useRef, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import "../../App.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Success from "../../asset/images/success.png";
import CompanyLogo from "../../asset/images/comlogo.png";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import QRCode from "qrcode.react";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { emptyCart } from "../../redux/action/cart/CartAction";
import path from "../../utils/constant/path";

const styles = {
  stepper: {
    padding: "30px 0px",
    "& .MuiStepLabel-alternativeLabel": {
      fontFamily: "Noto Sans",
      color: "#212529 !important",

      "& .MuiSvgIcon-root.MuiStepIcon-root ": {
        width: "0.75em",
        height: "0.75em",
        color: "#ced4da",
      },

      "& .MuiStepIcon-root.Mui-active": {
        fontWeight: 600,
        color: "#f7941d",
      },

      "& .MuiStepIcon-root.Mui-completed ": {
        fontWeight: 600,
        color: "#f7941d",
      },
    },

    "& .MuiStep-alternativeLabel .MuiStepConnector-lineHorizontal": {
      border: "1px solid #92278F",
    },
  },

  imgPayment: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "15px !important",
    borderBottom: "1px solid #fff",
    "& img": {
      width: 70,
    },
  },

  amount: {
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center"
  },

  formControl: {
    display: "block",
    width: "100%",
    // padding: "0.75rem 0.75rem",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "#fff",
    backgroundColor: "transparent",
    backgroundClip: "padding-box",
    border: "none",
    borderBottom: "1px solid #fff",
    appearance: "none",
    borderRadius: "0rem",
    transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
    marginTop: 10,
    "&:focus-visible": {
      outline: "none",
    },
  },

  textField: {
    "& div > input": {
      margin: "5px 0px",
    },

    "& div > div": {
      margin: "10px 0px",
    },
  },

  formCheck: {
    "& .MuiCheckbox-root.Mui-checked": {
      color: "#f7941d",
    },

    "& .MuiCheckbox-root": {
      paddingLeft: 0,
      paddingRight: 9,
      color: "#ced4da",
    },
  },

  header: {
    margin: "20px 0px",
  },

  card: {
    boxShadow: "0px 0px 10px #00000019 !important",
  },

  companyLogo: {
    width: 45,
    height: 45,
    boxShadow: "0px 0px 10px #92278F !important",
    borderRadius: "50%",
    padding: 5,
    position: "relative",
    margin: "20px auto",
  },

  creditCard: {
    background: " #FFF0FFB2 !important",
    background: "linear-gradient(to right, rgb(201, 75, 75), rgb(75, 19, 79))",
    borderRadius: "0.75rem !important",
    padding: 30,
    color: "#fff !important",
  },

  selectMonth: {
    "& .MuiSelect-select": {
      color: "#fff !important",
    },

    "& .MuiSelect-icon": {
      color: "#fff !important",
    },
    "& .MuiInput-root:before": {
      borderBottom: "1px solid #fff !important",
    },

    "& .MuiInput-root:after": {
      borderBottom: "1px solid #fff !important",
    },
  },

  imgVerification: {
    "& img": {
      width: 90,
      height: 60,
      margin: 10,
      width: "7.5rem",
      height: "5rem",
      margin: 5,
      padding: 5,
      // width:70, margin:20
    },
  },

  paymentcard: {
    border: "2px solid #ced4da",
    borderRadius: "0.5rem",
    margin: 5,
    padding: 20,
    cursor: "pointer",
    "& + .sampleSign": {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      paddingTop: 5,
    },

    "&:hover": {
      border: "2px solid #92278F",
    },
  },

  productCard: {
    textAlign: "center"
  },

  qrscanner: {
    "& img": {
      width: 150,
      height: 150,
    },

    textAlign: "center",
    margin: "auto",
    // padding:"19% 0%",
    display: "flex",
    justifyContent: "center",
    top: "20px !important",
    boxShadow: "none !important",
    background: "none !important",
    border: "none !important",
    top: "20px !important",
    width: "100% !important",
    padding: 10,
    margin: 0,
    background:
      "linear-gradient(to right, #F64E60 4px, transparent 4px) 0 0, linear-gradient(to right, #F64E60 4px, transparent 4px) 0 100%, linear-gradient(to left, #F64E60 4px, transparent 4px) 100% 0, linear-gradient(to left, #F64E60 4px, transparent 4px) 100% 100%, linear-gradient(to bottom,#F64E60 4px, transparent 4px) 0 0, linear-gradient(to bottom, #F64E60 4px, transparent 4px) 100% 0, linear-gradient(to top, #F64E60 4px, transparent 4px) 0 100%, linear-gradient(to top, #F64E60 4px, transparent 4px) 100% 100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
    left: 0,
  },
  cvv: {
    width: "100%",
    "& div": {
      padding: 10,
      display: "flex",
      justifyContent: "center",
    },
  },

  camera: {
    height: 60,
    width: 60,
  },

  borderOR: {
    width: 1,
    height: "32%",
    background: "#92278F",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  company: {
    boxShadow: "0px 0px 10px #00000019 !important",
    marginTop: -45,
    padding: 20,
    // display: "flex",
    // flexWrap: "wrap",
    // alignItems: "center",
    textAlign: "center"

  },

  companyName: {
    fontWeight: "bold",
    fontSize: "1rem",
    padding: "10px 0px",
  },

  billContent: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: "normal",
    padding: "5px 0px",
  },

  receipt: {
    border: "2px solid #ced4da",
    borderRadius: "0.5rem",
    margin: 5,
    padding: 10,
    display: "flex",
    justifyContent: "center",
  },

  receiptcard: {
    margin: 5,
    "& div": {
      marginBottom: 10,
    },
    "& div:last-child": {
      background: "#fff",
      border: "1px solid #f7941d",
      borderRadius: 4,
      textTransform: "uppercase",
      fontWeight: 600,
      padding: 15,
    },
  },
};

function SuccessTransact(props) {
  const [age, setAge] = React.useState("");
  const componentRef = useRef();

  const [transactionID, setTransactionID] = useState(
    "TNR" + Math.floor(100000 + Math.random() * 900000)
  );
  const [date, setDate] = useState(moment().format("DD/MM/YYYY hh:mm A"));
  const [amount, setAmount] = useState("1500");
  const [cardNumber, setCardNumber] = useState("5976-XXXX-XXXX-2134");
  const [name, setName] = useState("ALL CART");

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  useEffect(() => {
    props.emptyCart();
  })
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const continueShopping = () => {
    props.emptyCart();
    props.history.push(path.ProductList);
  };
  return (
    <>
      <div className="transact">
        <Grid
          container
          spacing={5}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={4} className="success-transact">
            <div className="card-transact" ref={componentRef}>
              <div>
                <img src={Success} className="img-success" />
              </div>
              <div className="txt-header">Payment Successful</div>

              <div className={props.classes.productCard}>
                <div>
                  <img src={CompanyLogo} style={{
                    width: 45, height: 45, boxShadow: "0px 0px 10px #92278F", borderRadius: "50%",
                    padding: 5,
                    position: "relative",
                    margin: "20px auto", background: "#fff"
                  }} className={props.classes.companyLogo} />
                </div>

                <Card className={props.classes.company} style={{
                  boxShadow: "0px 0px 10px #00000019",
                  marginTop: -45,
                  padding: 20,
                  textAlign: "center"
                }}>
                  <div className={props.classes.companyName} style={{ padding: "10px 0px", }}>
                    Starbuck, Inc
                  </div>

                  <Grid container>
                    <Grid item xs={12} className="fw-bold">
                      &#36; 400.00
                    </Grid>
                  </Grid>
                </Card>
              </div>

              <div className="summary" ref={componentRef}>
                <div className="transact-header">Transaction Details</div>
                <div class="d-flex justify-content-center">
                  <div className="w-50">Transaction ID</div>
                  <div className="w-50 fw-bold">{transactionID}</div>
                </div>

                <div class="d-flex justify-content-center">
                  <div className="w-50">Transaction Date</div>
                  <div className="w-50 fw-bold">{date}</div>
                </div>

                <div class="d-flex justify-content-center">
                  <div className="w-50">Amount Paid</div>
                  <div className="w-50 fw-bold">
                    &#36;
                    {props.location.state.data.Amount.toLocaleString("en-IN")}
                  </div>
                </div>

                <div class="d-flex justify-content-center">
                  <div className="w-50">Card Number</div>
                  <div className="w-50 fw-bold">
                    {props.location.state.data.cardNumber}
                  </div>
                </div>

                <div class="d-flex justify-content-center">
                  <div className="w-50">Payment Mode</div>
                  <div className="w-50 fw-bold">
                    {props.location.state.data.cardType || "NA"}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <div className="link-btn" onClick={continueShopping}>
                  Continue Shopping
                </div>
              </div>
            </div>
          </Grid>

          <Grid item xs={4} className="success-transact">
            <div className="card-transact">
              {/* <div className="txt-header">Bill Sharing</div> */}
              <div className={props.classes.paymentcard}>
                <div class="d-flex justify-content-center">
                  <div>
                    <div
                      class="d-flex justify-content-center font-16"
                      style={{ marginBottom: 10 }}
                    >
                      Scan for receipt
                    </div>
                    <div
                      className={props.classes.qrscanner}
                      style={{ marginBottom: 10 }}
                    >
                      <QRCode
                        includeMargin={true}
                        value={
                          transactionID +
                          "," +
                          date +
                          "," +
                          props.location.state.data.Amount +
                          "," +
                          props.location.state.data.cardNumber +
                          "," +
                          props.location.state.data.cardType
                        }
                      />
                    </div>
                  </div>
                </div>
                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <h3 className={props.classes.billContent}>In Total</h3>
                  </Grid>
                  <Grid item xs={5}>
                    <h5 class="subtotal">
                      &#36;{" "}
                      {(props.location.state.data.Amount - 3).toLocaleString(
                        "en-IN"
                      )}
                    </h5>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <h3 className={props.classes.billContent}>Shipping</h3>
                  </Grid>
                  <Grid item xs={5}>
                    <h5 class="subtotal">&#36;3</h5>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <h3 className={props.classes.billContent}>
                      Taxes and Charges
                    </h3>
                  </Grid>
                  <Grid item xs={5}>
                    <h5 class="subtotal">&#36;10</h5>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <h3 className={props.classes.billContent}>Order Total:</h3>
                  </Grid>
                  <Grid item xs={5}>
                    <h5 class="subtotal">
                      &#36;
                      {props.location.state.data.Amount.toLocaleString("en-IN")}
                    </h5>
                  </Grid>
                  <Grid item xs={5}></Grid>
                </Grid>

                {/* <div className={props.classes.receiptcard}>
                    <div className="d-flex justify-content-center">
                        <Link to="/" className="link-btn">
                            Accept
                        </Link>
                    </div>

                    <div className="d-flex justify-content-center">
                        <Link to="/">
                            Decline
                        </Link>
                    </div>
                    </div> */}
              </div>

              <div className="">
                <Link onClick={handlePrint} className={props.classes.receipt}>
                  Receipt Photo
                </Link>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  // entryFormList: state.EntryFormList.entryFormList,
  // bankList:
  //   state.BankList.bankList.data != null &&
  //     state.BankList.bankList.data.length != 0
  //     ? state.BankList.bankList.data
  //     : [],
  // loader: state.EntryFormList.isLoading,
  // loginDetails:state.Login.loginDetails.Table1!=null&&state.Login.loginDetails.Table1.length!=0?state.Login.loginDetails.Table1:[],
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ emptyCart }, dispatch);
};
export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SuccessTransact))
);
